import styled from "styled-components";
import theme from "components/shared/theme";

export const Section = styled.section`
  height: 500px;
  width: 100%;
  background-color: ${theme.colors.greenWit};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
`;

export const H1 = styled.h3`
  color: #2a3b49;
  font-weight: 800;
  font-size: 2.063em;
  font-family: Poppins, Helvetica, Arial, Lucida, sans-serif;
`;
export const H2 = styled.h2`
  font-size: 1em;
`;

export const ImagesSection = styled.div`
  margin-top: 1em;
  img {
    margin-left: 0.5em;
    margin-right: 0.5em;
  }
`;

export const DisclaimerSection = styled(ImagesSection)`
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
`;
